import React from "react";

import "./InsightStatements.scss";

class InsightStatements extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStory: 0,
    };
  }

  setActiveStory = (index) => {
    if (this.state.activeStory !== index) {
      this.setState({ activeStory: index });
      if (this.props.onSlideChange && typeof this.props.onSlideChange === "function") {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.props.onSlideChange(this.props.statements[index]);
        }, 200);
      }
    }
  };

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.statements != prevProps.statements) {
      this.setState({ activeStory: 0 });
    }
  }

  render() {
    const { statements } = this.props;
    const { activeStory } = this.state;
    return (
      <div className="insight-story-statements">
        {statements.map((d, i) => (
          <a
            key={d.statement}
            onClick={() => this.setActiveStory(i)}
            className={`insight-story-statement ${i === activeStory && "is-selected"}`}
            tabIndex={0}
          >
            {d.statement}
          </a>
        ))}
      </div>
    );
  }
}

export default InsightStatements;
